import React, { useState } from "react";
import { useFormik } from "formik";
import PropTypes from "prop-types";

import { EXCEL_SHEET_FORMATS } from "../../constants/constants";

import Button from "../../components/button";
import Error from "../../components/error";

const UploadCovidHotSportDataForm = props => {
  const [fileErr, setFileErr] = useState("");

  // validate excel sheet file
  const validateFile = file => {
    let error = "";
    if (file) {
      let tem = file.name.split(".");
      if (!EXCEL_SHEET_FORMATS.includes(tem[tem.length - 1].toLowerCase())) {
        error = "File must be an excel sheet";
        setFileErr(error);
        return false;
      }
    }
    setFileErr(error);
    return true;
  };

  const formik = useFormik({
    initialValues: {
      uploadFile: null
    },
    onSubmit: values => {
      if (values.uploadFile !== null) {
        props.onSheetSubmit(values.uploadFile);
      }
    }
  });

  return (
    <form className="d-flex flex-column" onSubmit={formik.handleSubmit}>
      <p>
        Upload COVID-19 Hot Spots CSV <span className="error">*</span>
      </p>
      <input
        type="file"
        onChange={event => {
          if (validateFile(event.currentTarget.files[0])) {
            formik.setFieldValue("uploadFile", event.currentTarget.files[0]);
          }
        }}
      />
      <Error>{fileErr}</Error>
      <br />
      <p className="mb-0 d-flex justify-content-center">
        <Button title="Upload" type="submit" />
      </p>
    </form>
  );
};

export default UploadCovidHotSportDataForm;

UploadCovidHotSportDataForm.defaultProps = {
  onSheetSubmit: () => {}
};

UploadCovidHotSportDataForm.propTypes = {
  onSheetSubmit: PropTypes.func
};
